import React, {
	createContext,
	useContext,
	useState,
	useEffect,
	useMemo,
} from 'react';
import {
	defaultColDefination,
	formatPercentageToSingleDecimal,
	initialGridData,
} from 'CategoryManagement/Explore/DetailedAnalysis/utils';
import { CategoryManagementContext } from 'contexts/CategoryManagementContext';
import { getSignificantGrowthSuppliers } from 'utils/apiRequests';
import { CategoryInsightsSettingsContext } from 'contexts/CategoryInsightsSettingsContext';
import { formatNumber } from 'utils/number';
import { getHeaderByTaxonomyType } from '../../CategoryManagement/utils';

const SignificantYoyGrowthContext = createContext();

const suppliersText = 'suppliers';

export const SignificantYoyGrowthProvider = ({ children }) => {
	const [isLoading, setIsLoading] = useState(false);
	const [analysis, setAnalysis] = useState(`No ${suppliersText}`);
	const [gridData, setGridData] = useState(initialGridData);
	const {
		currentSelectCategory,
		dateRangeData,
		isFetching,
		isDirect,
		isSourceable,
		taxonomyType,
	} = useContext(CategoryManagementContext);
	const { loading: isSettingsFetching } = useContext(
		CategoryInsightsSettingsContext
	);
	const { categoryName } = currentSelectCategory;
	const { dateFrom, dateTo } = dateRangeData;

	const taxonomyHeader = useMemo(() => getHeaderByTaxonomyType(taxonomyType), [
		taxonomyType,
	]);

	const columnDefs = [
		{ headerName: 'Vendor Name', field: 'vendoR_NAME' },
		{ headerName: `${taxonomyHeader} L1Category`, field: 'l1Category' },
		{ headerName: `${taxonomyHeader} L2Category`, field: 'l2Category' },
		{ headerName: `${taxonomyHeader} L3Category`, field: 'l3Category' },
		{ headerName: `${taxonomyHeader} L4Category`, field: 'l4Category' },
		{ headerName: 'Business Unit', field: 'purchasinG_GROUP' },
		{ headerName: 'AP L4 Vendor Growth', field: 'spendGrowthVendor' },
		{
			headerName: 'AP L4Category Growth',
			field: 'spendGrowthL4Category',
			sort: 'desc',
		},
	];

	useEffect(
		() => {
			if (!isSettingsFetching && !isFetching) {
				setIsLoading(true);
				if (
					categoryName !== '' ||
					categoryName !== null ||
					categoryName !== undefined
				) {
					const payLoad = {
						categoryName: categoryName,
						dateFrom: dateFrom,
						dateTo: dateTo,
						isSourceable: isSourceable,
						aptaxonomy: isDirect,
						taxonomyType: taxonomyType,
					};
					getSignificantGrowthSuppliers(payLoad)
						.then(response => {
							if (response.succeeded) {
								if (response.data.length > 0 || response.data !== null) {
									if (!!Object.keys(response.data).length) {
										if (response.data.explore.length > 0) {
											const filteredResult = response.data.explore.filter(
												obj =>
													obj.spendGrowthVendor >= 0 &&
													obj.spendGrowthL4Category >= 0
											);
											const rowResult = filteredResult.map(x => {
												return {
													...x,
													spendGrowthVendor: formatPercentageToSingleDecimal(
														x.spendGrowthVendor
													),
													spendGrowthL4Category: formatPercentageToSingleDecimal(
														x.spendGrowthL4Category
													),
												};
											});
											const analysisString = `${formatNumber(
												filteredResult.length
											)} ${suppliersText}`;
											setAnalysis(analysisString);
											setGridData(prevState => ({
												...prevState,
												rowData: rowResult,
												columnDefs: columnDefs,
												defaultColDef: defaultColDefination,
											}));
										} else {
											setGridData(initialGridData);
											setAnalysis(`0 ${suppliersText}`);
										}
										setIsLoading(false);
									}
								} else {
									setIsLoading(false);
								}
							} else {
								setIsLoading(false);
							}
						})
						.catch(() => setIsLoading(false));
				} else {
					setIsLoading(false);
				}
			}
		}, // eslint-disable-next-line
		[
			dateRangeData,
			categoryName,
			isSettingsFetching,
			isFetching,
			isDirect,
			isSourceable,
			taxonomyType,
		]
	);

	return (
		<SignificantYoyGrowthContext.Provider
			value={{ isLoading, analysis, gridData }}
		>
			{children}
		</SignificantYoyGrowthContext.Provider>
	);
};

export const useSignificantYoyGrowthContext = () => {
	return useContext(SignificantYoyGrowthContext);
};
